var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-management" },
    [
      _c(
        "div",
        {
          ref: "dropdown",
          staticClass: "card-management-dropdown",
          on: { blur: _vm.handleBlur },
        },
        [
          _c(
            "button",
            {
              staticClass: "card-management-dropdown-button",
              class: { "is-open": _vm.isOpen },
              attrs: { tabindex: "0" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleDropdown($event)
                },
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.toggleDropdown($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.toggleDropdown($event)
                  },
                ],
              },
            },
            [
              _c(
                "span",
                { staticClass: "card-management-dropdown-button-label" },
                [
                  _vm.selectedCard
                    ? _c("div", {
                        staticClass: "card-management--card-logo",
                        class: _vm.selectedCard.brand,
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.selectedCard
                          ? "*** " + _vm.selectedCard.last4
                          : _vm.useANewCreditCardLabel
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen",
                },
              ],
              staticClass: "card-management-dropdown-content",
            },
            [
              _c(
                "ul",
                { staticClass: "card-management-dropdown-content-card-list" },
                [
                  _vm.card.id
                    ? _c("div", { staticClass: "dropdown-content-heading" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.yourCardsLabel) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "card-management-dropdown-content-card-list--item",
                      class: { selected: _vm.isSelected(_vm.card.id) },
                      attrs: { tabindex: "0" },
                      on: {
                        click: function ($event) {
                          return _vm.selectCard(_vm.card)
                        },
                        keypress: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.selectCard(_vm.card)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.selectCard(_vm.card)
                          },
                        ],
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "card-management--card-logo",
                        class: _vm.card.brand,
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("*** " + _vm._s(_vm.card.last4))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-management-dropdown-content-heading" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.addCreditDebitCardLabel) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "card-management-dropdown-content-card-list--item add-card",
                      attrs: { tabindex: "0" },
                      on: {
                        click: _vm.addNewCard,
                        keypress: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.addNewCard($event)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.addNewCard($event)
                          },
                        ],
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "card-management--card-logo generic",
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.creditDebitCardLabel))]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.selectedCard
        ? _c("input", {
            attrs: { type: "hidden", name: "existingCardSelected" },
            domProps: { value: true },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.selectedCard
        ? _c("div", { staticClass: "card-management--card-brands" }, [
            _c("div", { staticClass: "card-management--card-logo VI" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-management--card-logo MC" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-management--card-logo AX" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-management--card-logo JC" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-management--card-logo UP" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.selectedCard && _vm.isUsingVgs
        ? _c("vgs-form", {
            ref: "vgsForm",
            attrs: {
              variant: "modify",
              "card-holder": _vm.tc("formFields.cardHolder"),
              "card-number-field": _vm.tc("formFields.cardNumber"),
              "exp-date-field": _vm.tc("formFields.cardExpirationDate"),
              "cvc-field": _vm.tc("formFields.cardCvc"),
              "vgs-endpoint": _vm.vgsBaseUrl,
              "field-class": "input",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.selectedCard && !_vm.isUsingVgs ? _c("credit-card-form") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }